import { render } from "./WCSimpleToast.vue?vue&type=template&id=44c6f705&scoped=true"
import script from "./WCSimpleToast.vue?vue&type=script&lang=js"
export * from "./WCSimpleToast.vue?vue&type=script&lang=js"

import "./WCSimpleToast.vue?vue&type=style&index=0&id=44c6f705&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c6f705"]])

export default __exports__